import gsap, { Power2, Power4 } from 'gsap';

import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import { GetBy } from '../_app/cuchillo/core/Element';

class ScrollItem__BlockJunkIntro extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.holder = GetBy.class("holder", this.item)[0];

        this.onShow = () => {
            gsap.to(this.holder, {
                opacity: 2,
                duration: .5,
                ease: Power4.easeIn
            });
        };

        this.onHide = () => {
            gsap.to(this.holder, {
                opacity: 0,
                duration: .2,
                ease: Power2.easeOut
            });
        };
    }

    dispose() {
        super.dispose();
    }
}

Scroll._registerClass('BlockJunkIntro', ScrollItem__BlockJunkIntro);

export default ScrollItem__BlockJunkIntro;
